// extracted by mini-css-extract-plugin
export default {"title":"RecordFilter_title__bxaJh","deleteButton":"RecordFilter_deleteButton__nYQ3i","entityField":"RecordFilter_entityField__XbpXc","footer":"RecordFilter_footer__2mmQf"};